<template>
  <div class="imei-transfer-list table-hook fadeInRight">
    <div class="title-box">
      <span class="m-title">调货列表</span>
      <el-form inline class="hook right themed-form search-form" :model="form" style="line-height: 40px;">
        <el-form-item label="客户名称:">
          <el-select v-model="form.name" filterable placeholder="请选择" clearable>
            <el-option v-for="item in domainDeviceIpList" :key="item.flowDomain" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IMEI:">
          <el-input v-model="form.imei" placeholder="请输入IMEI"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" placeholder="请选择状态" clearable>
            <el-option label="待调货" value="0"></el-option>
            <el-option label="已调货" value="1"></el-option>
            <el-option label="调货失败" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-upload" class="themed-button" @click="dialogBox = true">批量导入</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-box">
      <el-table :data="tableData" stripe border :max-height="maxTableHeight">
        <el-table-column label="ID" prop="id" show-overflow-tooltip></el-table-column>
        <el-table-column label="IMEI" prop="imei" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" prop="status" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待调货</span>
            <span v-else-if="scope.row.status == 1">已调货</span>
            <span v-else-if="scope.row.status == 2">调货失败</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 50, 100, 1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="批量导入" :visible.sync="dialogBox" width="600px">
      <el-form :model="importForm" label-width="120px" ref="importFormRef">
        <el-form-item label="选择excel文件:">
          <input type="file" ref="importFile" />
          <div style="font-size: 12px; color: #888;">仅支持.xls/.xlsx格式</div>
        </el-form-item>
        <el-form-item label="IMEI:">
          <el-input v-model="importForm.imeis" type="textarea" placeholder="请输入IMEI，多个IMEI换行分隔"></el-input>
        </el-form-item>
        <el-form-item label="客户名称:">
          <el-select v-model="importForm.name" filterable placeholder="请选择" clearable>
            <el-option v-for="item in domainDeviceIpList" :key="item.flowDomain" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        
        <el-button type="primary" class="themed-button" @click="handleImport">导入</el-button>
        <el-button type="primary" class="themed-button" @click="exportTemplate">导出excel模板</el-button>
        <el-button type="primary" class="themed-button"  @click="dialogBox = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listTransfer, batchImportSync } from '@/api/meCardBindManagement/imeiTransferList.js'
import {exportTemplate} from '@/api/statistics.js'
import Utils from '@/utils/utils.js'

export default {
  data() {
    return {
      form: {
        imei: '',
        name: '',
        status: '',
      },
      tableData: [],
      pageSize: 15,
      currentPage: 1,
      total: 0,
      maxTableHeight: 500,
      dialogBox: false,
      importForm: {
        imeis: '',
        name: '',
      },
    }
  },
  computed: {
    ...mapGetters(['domain_device_ip']),
    domainDeviceIpList() {
      return Array.isArray(this.domain_device_ip) ? this.domain_device_ip : []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    searchData() {
      this.currentPage = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    getList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        name: this.form.name,
        imei: this.form.imei,
        status: this.form.status,
      }
      listTransfer(params).then(res => {
        if (res.page) {
          this.total = res.page.total
          this.tableData = res.page.rows
        } else {
          this.total = 0
          this.tableData = []
        }
      })
    },
    handleImport() {
      const file = this.$refs.importFile.files[0]
      if (!file && !this.importForm.imeis) {
        this.$message.error('请上传文件或输入IMEI')
        return
      }
      if (!this.importForm.name) {
        this.$message.error('请选择客户名称')
        return
      }
      const formData = new FormData()
      if (file) formData.append('fileurl', file)
      if (this.importForm.imeis) formData.append('imeis', this.importForm.imeis)
      // 取客户下拉的flowDomain
      const selected = this.domainDeviceIpList.find(i => i.name === this.importForm.name)
      if (selected) formData.append('flowUrl', selected.flowDomain)
      formData.append('name', this.importForm.name)
      batchImportSync(formData).then(res => {
        if (res.system_result_key == '0') {
          if (file) {
            this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
              confirmButtonText: '确定',
            }).then(() => {
              this.$refs.importFile.value = ''
              this.importForm.imeis = ''
              this.importForm.name = ''
              this.dialogBox = false
              this.getList()
              this.$router.push('/tob/i_import_list')
            })
          } else {
            this.$message.success(res.system_result_message_key || '导入成功')
            this.importForm.imeis = ''
            this.importForm.name = ''
            this.dialogBox = false
            this.getList()
          }
        } else {
          this.$message.error(res.system_result_message_key || '导入失败')
        }
      })
    },
    exportTemplate() {
      exportTemplate({name: 'importImei.xls'}).then(res => {
        const filename = 'importImei.xls'
        Utils.createDownload(res, filename)
      })
    }
  },
}
</script>

<style scoped>
.imei-transfer-list .title-box {
  margin-bottom: 20px;
}
.imei-transfer-list .content-box {
  margin-bottom: 20px;
}
.imei-transfer-list .pagination {
  text-align: right;
}
</style> 